/* 
  START: you can define custom functions within this area
  v v v v v v v v v v v v v v v v v v v v v v v v v v v
*/

function bindLiveChatClick() {
    var chatlink = document.querySelector('a[href="#liveChat"]');
    if (chatlink) {
        chatlink.addEventListener('click', openLiveChat, false);
    }
}
function openLiveChat(e) {
    e.preventDefault();
    if (typeof olark !== "undefined") {
        olark('api.box.expand');
    }
    return false;
}

function bindCookiePrefsClick() {
    var cookielink = document.querySelector('a[href="#CookiePreferences"]');
    if (cookielink) {
        cookielink.addEventListener('click', openCookiePrefs, false);
    }
}
function openCookiePrefs(e) {
    e.preventDefault();
    if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not loaded yet.');
    }
    return false;
}

/* PLP sticky filter bar */
function initPLPStickyNav() {
  var collectionNavBar = $('.navigation--root[data-sticky="true"]');
  let plpNavTop = collectionNavBar.offset().top;
  
  function plpstickynavbar() {
    //window.console.log('window.scrollY='+window.scrollY+' plpNavTop='+ plpNavTop);
    var annHeight = document.documentElement.style.getPropertyValue('--announcement-height').replace('px', '');
    var hdrHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    var scrollTrigger = (window.scrollY + parseInt(annHeight) + parseInt(hdrHeight));
    //window.console.log('scrollTrigger=', scrollTrigger);
    if (scrollTrigger >= plpNavTop) {    
      collectionNavBar.addClass('is-stuck');
    } else {
      collectionNavBar.removeClass('is-stuck');    
    }
  }
  plpstickynavbar();
  window.addEventListener('scroll', plpstickynavbar);
}
/* END: PLP sticky filter bar */

/* PDP sticky ATC */
function initPDPStickyATC() {
  var pdpBuyBtns = $('.product-buy-buttons--root[data-sticky="true"]');
  var parentBlock = pdpBuyBtns.closest('.product-page--block');
  var pdpForm = parentBlock.closest('.product-page--form');
  let atcTop = pdpBuyBtns.offset().top;
  var livechat = $('.olark-launch-button-wrapper.olark-bottom-left');
  
  function pdpstickyatc() {
    //window.console.log('window.scrollY='+window.scrollY+' atcTop='+ atcTop);
    var btnHeight = pdpBuyBtns.height();
    var scrollTrigger = (window.scrollY); // + parseInt(annHeight) + parseInt(hdrHeight));
    //window.console.log('scrollTrigger=', scrollTrigger);
    if (scrollTrigger >= atcTop) {    
      parentBlock.css('height', btnHeight);
      pdpForm.addClass('atc-is-stuck');
      pdpBuyBtns.addClass('is-stuck animate-in');
      
      $('.olark-launch-button-wrapper.olark-bottom-left').addClass('atc-sticky-active');
      
    } else {
      parentBlock.removeAttr('style');
      pdpBuyBtns.removeClass('is-stuck animate-in');   
      pdpForm.removeClass('atc-is-stuck');
      
      $('.olark-launch-button-wrapper.olark-bottom-left').removeClass('atc-sticky-active');      
    }
  }
  pdpstickyatc();
  window.addEventListener('scroll', pdpstickyatc);
}
/* END: PDP sticky ATC bar */

function accessibilityFixes() {
  $('body').on('keydown', 'a, [role="button"]', function(e) {
      if (e.key === ' ') {
        e.preventDefault(); // Prevent default spacebar behavior (scrolling)
        $(this).trigger('click'); // Trigger the button's click event
      }
  });
}

function initTabs() {
  var tabsRoot = $('.tabs--root');
  if (tabsRoot.length) {
    tabsRoot.each((i,el)=>{
      var tabs = $(el).find('.tabs--menu-item');
      tabs.on( "click", function(e) {
        e.preventDefault();  
        var tab = $(this);
        tab.addClass('active-tab').siblings().removeClass('active-tab'); 
        var pnlId = tab.find('a').attr('href');
        var pnl = $(el).find(pnlId);
        pnl.addClass('active-panel').siblings().removeClass('active-panel');
        return false;
      });
    });
  }
}

function initTeamsModal() {
  var leaguesList = $('.leagues-with-icon--list');
  var teamsModal = $('.modal--root[data-id="teams"] .leagues-teams--container');
  if (leaguesList.length && teamsModal.length) {
      leaguesList.on('click', '.leagues-with-icon--link', function (e) {
        var modalTrigger = $(this);
        var handle = modalTrigger.data('handle');
        var activeTab = teamsModal.find('.tabs--menu-item[data-handle="'+handle+'"]');
        activeTab.trigger('click');
    });
  }
}

/* 
  ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
  END: area to define custom functions
  =====================================================
*/


/* 
  jQueryIsReady is just like like $(document).ready() - put your jQuery code here to avoid timing errors
*/
var jQueryIsReady = function() {
  /* 
    START: add any jQuery code or call functions that DEPEND on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */

  accessibilityFixes();
  initTabs();
  initTeamsModal();

  if ( $('.navigation--root[data-sticky="true"]').length ) {
    initPLPStickyNav();
  }
  
  if ($('.product-buy-buttons--root[data-sticky="true"]').length) {
    initPDPStickyATC();
  }
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: code that DEPENDS on jQuery goes in the area above
  */
} 
// end jQueryIsReady
// ========================================================================

/* 
  dkCustomInit is a function that runs immediately on page load, 
  but may finish before jQuery is fully loaded
*/
function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);

  /* 
    START: call any functions that DON'T depend on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */

  bindLiveChatClick();
  bindCookiePrefsClick();  
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: functions that DON'T depend on jQuery
    =====================================================
  */ 
}
// end dkCustomInit
// ========================================================================


/* LEAVE THIS AT THE BOTTOM OF THE FILE AND DO NOT EDIT */
if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
};

